import FetchService from "./Shared/FetchService";
export default class EventService {
    static getAlertEvents(params) {
        return FetchService.get("/aviso/advisor/events", {
            offset: params.offset,
            maxRows: params.maxRows,
            newsfeedFilter: params.alertStatus === "closed" ? 2 : 1,
            newsfeedCourseRiskFilterLevel: params.courseRiskId,
            newsfeedTermRiskFilterLevel: params.termRiskId,
            newsfeedTagFilter: params.tagId,
        });
    }
}
